import * as actions from './actions'

// Groupes d'options des produits vendus en ligne (accompagnement, suppléments…)
export default {
    namespaced: true,
    state: {},
    getters: {},
    actions,
    mutations: {}
}
